export default __webpack_public_path__ + "static/media/About_BG-03.2d6efbbb.png";